import {Pipe, PipeTransform} from '@angular/core';
import { Store } from '@ngxs/store';
import { InventoryState } from '../../states/inventory/inventory.state';

@Pipe({
  name: 'locationsList',
})
export class LocationsListPipe implements PipeTransform {
  /**
   *
   */
  constructor(private store: Store) {}

  transform(value: string[]) {
    if (!value?.length) {
       return '';
    }
    const locations = this.store.selectSnapshot(InventoryState.locations);
    if (!locations?.length)
      return '';
    
    return locations
        ?.filter(x => value.includes(x.id))
        ?.map(x => x.name)
        ?.reduce((prev, cur) => prev + ", " + cur);
  }
}  
